import dayjs from "dayjs";

const LOCAL_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const toLocalDateTime = (value?: string | null): string =>
  dayjs(value ?? undefined).format(LOCAL_DATE_TIME_FORMAT);
